import { VideoImportStep } from '../types';
import ContentUpload from './ContentUpload';
import BrandingSelect from './BrandingSelect/BrandingSelect';
import TemplateSelect from './TemplateSelect/TemplateSelect';
import Done from './Done';

export const VIDEO_IMPORT_STEPS: VideoImportStep[] = [
  {
    id: 'content-upload',
    index: 0,
    component: ContentUpload,
    title: 'Import Your Video',
    description:
      'Get weeks worth of content out of your webinars, product demos, video podcasts, or any other long-form video content.'
  },
  {
    id: 'branding-select',
    index: 1,
    component: BrandingSelect,
    title: 'Branding',
    description: 'Add a splash of branding to your clips. You can always edit your brand settings in Brand Kit later.'
  },
  {
    id: 'template-select',
    index: 2,
    component: TemplateSelect,
    title: 'Templates',
    description: 'Select templates you want to use for your clips. You can always edit these later.'
  },
  {
    id: 'done',
    index: 3,
    component: Done,
    title: 'That was easy!',
    description: ''
  }
];
